import * as list from './list';

export default {
  ...list,
};
